import { IonIcon } from '@ionic/react';
import { walletOutline } from 'ionicons/icons';

export default function IndividualWalletCreationDialog() {
  return (
    <div className="space-y-4 py-4">
      <div className="flex items-center justify-center gap-4">
        <IonIcon
          icon={walletOutline}
          className="text-primary opacity-40 size-16"
        />

        <div className="flex-1">
          <h5 className="font-semibold high-emphasis-text">
            Create your wallet
          </h5>
          <p className="medium-emphasis-text">
            Your KYC is complete. Proceed to create the individual wallet.
          </p>
        </div>
      </div>
    </div>
  );
}
